import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const DashboardIcon = (props: Omit<PosIconProps, 'viewBox'>) => {
  return (
    <SvgWrapper viewBox="0 0 20 20" {...props}>
      <path
        d="M10 5.40023C13.6609 5.40023 16.6283 8.42954 16.6283 12.1667C16.6283 13.5908 16.1975 14.9101 15.4611 16H17.066C17.6622 14.8569 18 13.552 18 12.1667C18 7.65634 14.4183 4 10 4C5.58172 4 2 7.65634 2 12.1667C2 13.552 2.33782 14.8569 2.93404 16H4.53886C3.80247 14.9101 3.37165 13.5908 3.37165 12.1667C3.37165 8.42954 6.33914 5.40023 10 5.40023Z"
        fill="inherit"
      />
      <path
        d="M13 9L10 12"
        stroke={props.fill}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </SvgWrapper>
  );
};
